export const eduSystemAu = [
  {
    name: "Select",
    value: "",
  },
  {
    name: "Diploma",
    value: "Diploma",
  },
  {
    name: "Advanced Diploma",
    value: "Advanced Diploma",
  },
  {
    name: "Graduate Diploma",
    value: "Graduate Diploma",
  },
  {
    name: "Certificate I",
    value: "Certificate I",
  },
  {
    name: "Certificate II",
    value: "Certificate II",
  },
  {
    name: "Certificate III",
    value: "Certificate III",
  },
  {
    name: "Certificate IV",
    value: "Certificate IV",
  },
  {
    name: "Vocational (VET)",
    value: "Vocational (VET)",
  },
  {
    name: "Bachelor Degree",
    value: "Bachelor Degree",
  },

  {
    name: "Master Degree",
    value: "Master Degree",
  },
  {
    name: "PhD",
    value: "PhD",
  },
];
